var map = {
	"./NLlog.png": 20,
	"./Team1.jpg": 21,
	"./cohorts-reader-1A.png": 71,
	"./cohorts-reader-2A.png": 72,
	"./cohorts-reader-3A.png": 73,
	"./cohorts-reader-4A.png": 74,
	"./cta-illustration.svg": 75,
	"./feature-tile-icon-01.svg": 76,
	"./feature-tile-icon-02.svg": 77,
	"./feature-tile-icon-03.svg": 78,
	"./feature-tile-icon-04.svg": 79,
	"./feature-tile-icon-05.svg": 80,
	"./feature-tile-icon-06.svg": 81,
	"./illustration-section-01.svg": 82,
	"./illustration-section-02.svg": 83,
	"./logo.svg": 84,
	"./modern-reader-1A.png": 22,
	"./modern-reader-2A.png": 23,
	"./modern-reader-3A.png": 24,
	"./modern-reader-4A.png": 25,
	"./video-placeholder.jpg": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;